import { Injectable } from '@angular/core';
import { BookWidgetFieldUpdateTypes } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { flexAirportRulesOnChangeEval } from '../../../adapters/book-widget-fields-rules/on-change/flex-airport-rules-on-change.adapter';
import { flexDatesRulesOnChangeEval } from '../../../adapters/book-widget-fields-rules/on-change/flex-dates-rules-on-change.adapter';
import { shopMilesRulesOnChangeEval } from '../../../adapters/book-widget-fields-rules/on-change/shop-miles-rules-on-change.adapter';
import { tripTypeRulesOnChangeEval } from '../../../adapters/book-widget-fields-rules/on-change/trip-type-rules-on-change.adapter';
import * as fromBookWidgetActions from '../../actions/book-widget.actions';
import {
  getBookWidgetFields,
  getBookWidgetFieldsMasterConfig
} from '../../selectors/book-widget.selectors';
import { isBusinessUser } from '../../selectors/login-dashboard.selectors';
@Injectable({
  providedIn: 'root'
})
export class BookWidgetFieldsUpdateEffects {
  constructor(private Actions$: Actions, private store: Store) {}
  updateBookWidgetShopMilesChange$ = createEffect(
    (): Observable<Action> =>
      this.Actions$.pipe(
        ofType(fromBookWidgetActions.BookWidgetFieldChange),
        filter(
          ({ bookWidgetFieldUpdateEvent }) =>
            bookWidgetFieldUpdateEvent.type ===
            BookWidgetFieldUpdateTypes.shopMiles
        ),
        concatLatestFrom(() => [
          this.store.select(getBookWidgetFields),
          this.store.select(getBookWidgetFieldsMasterConfig),
          this.store.select(isBusinessUser)
        ]),
        switchMap(
          ([
            { bookWidgetFieldUpdateEvent },
            bookWidgetFields,
            bookWidgetFieldsMasterConfig,
            isBusinessUserValue
          ]) => {
            const updatedBookWidgetFields = shopMilesRulesOnChangeEval(
              bookWidgetFields,
              bookWidgetFieldsMasterConfig,
              isBusinessUserValue
            );
            return of(
              fromBookWidgetActions.ApplyBookWidgetFieldChangeRules({
                bookWidgetFields: updatedBookWidgetFields,
                bookWidgetFieldUpdateEvent
              })
            );
          }
        )
      )
  );

  updateBookWidgetFlexDatesChange$ = createEffect(
    (): Observable<Action> =>
      this.Actions$.pipe(
        ofType(fromBookWidgetActions.BookWidgetFieldChange),
        filter(
          ({ bookWidgetFieldUpdateEvent }) =>
            bookWidgetFieldUpdateEvent.type ===
            BookWidgetFieldUpdateTypes.flexDates
        ),
        concatLatestFrom(() => [
          this.store.select(getBookWidgetFields),
          this.store.select(getBookWidgetFieldsMasterConfig)
        ]),
        switchMap(
          ([
            { bookWidgetFieldUpdateEvent },
            bookWidgetFields,
            bookWidgetFieldsMasterConfig
          ]) => {
            const updatedBookWidgetFields = flexDatesRulesOnChangeEval(
              bookWidgetFields,
              bookWidgetFieldsMasterConfig
            );
            return of(
              fromBookWidgetActions.ApplyBookWidgetFieldChangeRules({
                bookWidgetFields: updatedBookWidgetFields,
                bookWidgetFieldUpdateEvent
              })
            );
          }
        )
      )
  );

  updateBookWidgetFlexAirportChange$ = createEffect(
    (): Observable<Action> =>
      this.Actions$.pipe(
        ofType(fromBookWidgetActions.BookWidgetFieldChange),
        filter(
          ({ bookWidgetFieldUpdateEvent }) =>
            bookWidgetFieldUpdateEvent.type ===
            BookWidgetFieldUpdateTypes.flexAirport
        ),
        concatLatestFrom(() => [
          this.store.select(getBookWidgetFields),
          this.store.select(getBookWidgetFieldsMasterConfig)
        ]),
        switchMap(
          ([
            { bookWidgetFieldUpdateEvent },
            bookWidgetFields,
            bookWidgetFieldsMasterConfig
          ]) => {
            const updatedBookWidgetFields = flexAirportRulesOnChangeEval(
              bookWidgetFields,
              bookWidgetFieldsMasterConfig
            );
            return of(
              fromBookWidgetActions.ApplyBookWidgetFieldChangeRules({
                bookWidgetFields: updatedBookWidgetFields,
                bookWidgetFieldUpdateEvent
              })
            );
          }
        )
      )
  );

  updateBookWidgetTripTypeChange$ = createEffect(
    (): Observable<Action> =>
      this.Actions$.pipe(
        ofType(fromBookWidgetActions.BookWidgetFieldChange),
        filter(
          ({ bookWidgetFieldUpdateEvent }) =>
            bookWidgetFieldUpdateEvent.type ===
            BookWidgetFieldUpdateTypes.tripType
        ),
        concatLatestFrom(() => [this.store.select(getBookWidgetFields)]),
        switchMap(([{ bookWidgetFieldUpdateEvent }, bookWidgetFields]) => {
          const updatedBookWidgetFields =
            tripTypeRulesOnChangeEval(bookWidgetFields);
          return of(
            fromBookWidgetActions.ApplyBookWidgetFieldChangeRules({
              bookWidgetFields: updatedBookWidgetFields,
              bookWidgetFieldUpdateEvent
            })
          );
        })
      )
  );
}
